<top-nav locale="{{locale}}"></top-nav>
<!-- <top-nav-dynamic></top-nav-dynamic> -->
<kui-theme theme="light" withCanvas withReset style="background-color:#fff">
    <router-outlet></router-outlet>
    <div id="psPar" class="outside-page"></div>
    <back-to-top></back-to-top>
</kui-theme>